import React from 'react'
import ViewAssessment from './ViewAssessment'
import './ViewAssessment.scss'

const ViewAssessmentContainer = (props: any) => {
  const { data } = props
  return (
    <ViewAssessment data={data}/>
  )
}

export default ViewAssessmentContainer